import React, { useEffect } from 'react';
import { Box, Grid, Divider, Button, Tooltip, IconButton } from '@mui/material';
import CustomDialog from '../../../sharedcomponents/dialog/dialog';
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';
import TextField from '@mui/material/TextField';
import { useState } from '@hookstate/core';
import Helper from '../../../utility/helper';
import Title from '../../../sharedcomponents/title/title';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import CircularProgress from '@mui/material/CircularProgress';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import dayjs from 'dayjs';
//import { ScheduleDataService } from '../../services/ScheduleService';
import MUIDatePicker from '../../../sharedcomponents/datePicker';
import TitleWithoutNBAAction from '../../../sharedcomponents/title/titlewithoutnbaaction';
import CancelIcon from '@mui/icons-material/Cancel';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const EditParticipant = (props) => {
    const userRole = useState(null);
    const userInfo = useState(null);
    const userStatus = useState(1);
    const loading = useState(false);
    const [activityDate, setActivityDate] = React.useState(null);
    const [locationInfo, setLocationInfo] = React.useState([]);
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [activityTime, setActivityTime] = React.useState(null);
    const [disabledFlag, setDisabledFlag] = React.useState(false);
    const [disabledDefaultFlag, setDisabledDefaultFlag] = React.useState(false);
    // const [date, setDate] = React.useState('0001-01-01T00:00:00');
    // const [time, setTime] = React.useState(
    //     dayjs('0001-01-01T00:00:00').format('HH:mm:ss')
    // );
    const [playerDate, setPlayerDate] = React.useState(null);
    // const [playerTime, setPlayerTime] = React.useState(null);

    useEffect(() => {
        if (props.eventUserInfo && userInfo.get() == null) {
            const eventUserInfo = props.eventUserInfo;
            // console.log('eventUserInfo', eventUserInfo);
            setLocationInfo(eventUserInfo.locations);
            userInfo.set(eventUserInfo);
            setActivityDate(eventUserInfo.scheduleDateTime);
            userRole.set(eventUserInfo.roleID);
            userStatus.set(eventUserInfo.status);
            setActivityTime(
                dayjs(eventUserInfo.scheduleDateTime).format('HH:mm:ss')
            );
            setPlayerDate(
                eventUserInfo.locations && eventUserInfo.locations.length > 0
                    ? eventUserInfo.locations[0].playerDate
                    : null
            );
            // setPlayerTime(dayjs(eventUserInfo.playerDate).format('HH:mm:ss'));
        }
    }, []);

    const setCustomActivitydate = (value, mediaCircuitID) => {
        let newDatas = [];
        locationInfo.map((val) => {
            if (val.mediaCircuitID === mediaCircuitID) {
                const newTime =
                    dayjs(value).format('YYYY-MM-DD') +
                    ' ' +
                    dayjs(
                        val.scheduleDateTime ? val.scheduleDateTime : value
                    ).format('HH:mm:ss');
                // console.log("newTime", newTime, dayjs(val.scheduleDateTime).format("HH:mm:ss"));
                newDatas.push({
                    ...val,
                    scheduleDateTime: dayjs(newTime).format(
                        'YYYY-MM-DDTHH:mm:ss'
                    ),
                });
            } else {
                newDatas.push(val);
            }
            setPlayerDate(null);
        });
        setLocationInfo(newDatas);
        setDisabledDefaultFlag(true);
    };
    const setCustomActivityTime = (value, mediaCircuitID) => {
        console.log("value", value, mediaCircuitID);
        let newDatas = [];
        locationInfo.map((val) => {
            if (val.mediaCircuitID === mediaCircuitID) {
                const scheduleDateTimeUpdated = val.scheduleDateTime !== null ? val.scheduleDateTime : new Date()
                const newDate =
                    dayjs(scheduleDateTimeUpdated).format('YYYY-MM-DD') +
                    ' ' +
                    value;
                // console.log("newDate", newDate);
                newDatas.push({
                    ...val,
                    scheduleDateTime: dayjs(newDate).format(
                        'YYYY-MM-DDTHH:mm:ss'
                    ),
                });
            } else {
                newDatas.push(val);
            }
        });
        setLocationInfo(newDatas);
        setDisabledDefaultFlag(true);
    };
    // console.log("locationInfo", locationInfo);
    const setDefaultTime = (val) => {
        let newDate;
        if (playerDate !== null) {
            newDate = dayjs(playerDate).format('YYYY-MM-DD') + ' ' + val;
            setPlayerDate(dayjs(newDate).format('YYYY-MM-DDTHH:mm:ss'));
        } else {
            newDate = dayjs(new Date()).format('YYYY-MM-DD') + ' ' + val;
            setPlayerDate(dayjs(newDate).format('YYYY-MM-DDTHH:mm:ss'));
        }
        let newDatas = [];
        locationInfo.map((val) => {
            // console.log("newDate", newDate);
            newDatas.push({
                ...val,
                playerDate: dayjs(newDate).format('YYYY-MM-DDTHH:mm:ss'),
            });
        });
        setLocationInfo(newDatas);
        setDisabledFlag(false);
    };
    const setDefaultDate = (val) => {
        setPlayerDate(dayjs(val).format('YYYY-MM-DDTHH:mm:ss'));
        let newDate = dayjs(val).format('YYYY-MM-DDTHH:mm:ss');
        let newDatas = [];
        locationInfo.map((val) => {
            newDatas.push({
                ...val,
                playerDate: dayjs(newDate).format('YYYY-MM-DDTHH:mm:ss'),
            });
        });
        setDisabledFlag(false);
        setDisableBtn(false);
    };
    const handleReset = () => {
        setDisabledDefaultFlag(false);
        setDisabledFlag(false);
        setDisableBtn(true);
        // setDate(dayjs('0001-01-01T00:00:00').format('HH:mm:ss'));
        // setDate('0001-01-01T00:00:00');
        if (props.eventUserInfo) {
            const eventUserInfo = props.eventUserInfo;
            console.log('eventUserInfo', eventUserInfo);
            setLocationInfo(eventUserInfo.locations);
            userInfo.set(eventUserInfo);
            setActivityDate(eventUserInfo.scheduleDateTime);
            userRole.set(eventUserInfo.roleID);
            userStatus.set(eventUserInfo.status);
            setActivityTime(
                dayjs(eventUserInfo.scheduleDateTime).format('HH:mm:ss')
            );
            setPlayerDate(
                eventUserInfo.locations && eventUserInfo.locations.length > 0
                    ? eventUserInfo.locations[0].playerDate
                    : null
            );
            // setPlayerTime(dayjs(eventUserInfo.playerDate).format('HH:mm:ss'));
        }
    };
    const handleDisableBtn = () => {

        let prevData = {
            activityDate: '',
        };
        let currentData = {
            activityDate: activityDate,
        };
        if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
            setDisableBtn(true);

        } else {
            setDisableBtn(false);
        }
    };
    const handleClick = () => {
        // if (activityDate === "0001-01-01T00:00:00") {
        //     props.setSnackBarProps({
        //         ...props.snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please select Activity Date Time',
        //     });
        // } else {
        loading.set(true);
        const eventInfo = Helper.getStorage('eventInfo');
        // const userInfos = Helper.getStorage('userInfo');
        // let activityDateTime = Helper.FormatYearDate(activityDate) + 'T' + activityTime;

        const postLocationData = [];
        locationInfo.map((val) => {
            // console.log("val", val);
            // if (val.scheduleDateTime !== '0001-01-01T00:00:00') {
            console.log(val.scheduleDateTime);
            postLocationData.push({
                eventID: eventInfo.eventID,
                mediaCircuitID: val.mediaCircuitID,
                scheduleDateTime:
                    val.scheduleDateTime === 'Invalid date'
                        ? null
                        : val.scheduleDateTime,
                playerDate:
                    playerDate === '0001-01-01T00:00:00' ? null : playerDate,
            });
            // }
        });
        let validNumbers = 0;
        // postLocationData.map((vals) => {
        //     if (vals.scheduleDateTime.match('0001-01-01') !== null) {
        //         props.setSnackBarProps({
        //             ...props.snackBarProps,
        //             openSnack: true,
        //             variant: 'error',
        //             message: 'Please Enter Date',
        //         });
        //         loading.set(false);
        //         validNumbers += 1;
        //     }
        // });
        // console.log("validNumbers", validNumbers);
        if (validNumbers === 0) {
            let requestObj = {
                userIDs: userInfo.get().userID.toString(),
                eventID: eventInfo.eventID,
                modifiedBy: userInfo.get().userID,
                mediaCircuitLocationTime: postLocationData,
                deleteFlag: false,
            };
            ApiHelper.post(
                APIURLConstants.SET_USER_MEDIA_CIRCUIT_TIME,
                requestObj
            )
                .then((res) => {
                    if (res.data) {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Participant Timing updated successfully',
                        });
                        props.handleClose();
                        props.getParticipants();
                    }
                })
                .catch((error) => {
                    console.log('error : ', error);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while updating participant';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                });
        }
    };

    const handleClearActivityDateTime = (mediaCircuitID) => {
        if (mediaCircuitID) {
            let newDatas = [...locationInfo];
            let newIndex = newDatas.findIndex(i => i.mediaCircuitID === mediaCircuitID);
            if (newIndex != -1) {
                newDatas[newIndex].scheduleDateTime = null
            }
            setLocationInfo(newDatas);
        }
        else {
            setPlayerDate(null);
        }
        setDisableBtn(false);
        setDisabledFlag(false);
        setDisabledDefaultFlag(false);
    }

    const renderDialogContent = () => {
        return (
            <>
                {userInfo.get() ? (
                    <>
                        <TitleWithoutNBAAction
                            title={`User : ${userInfo.get().participant}`}
                            sx={{
                                ml: 0,
                            }}
                            px={0}
                        />
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 1,
                                justifyContent: 'center',
                                mx: 4,
                                paddingBottom: 2,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    paddingLeft: 13,
                                    pr: 1,
                                }}>
                                <MUIDatePicker
                                    label="Activity Date Time"
                                    value={
                                        playerDate === null
                                            ? null
                                            : playerDate ===
                                                '0001-01-01T00:00:00' ||
                                                playerDate.match(
                                                    '0001-01-01'
                                                ) !== null
                                                ? null
                                                : playerDate
                                    }
                                    error={false}
                                    setValue={setDefaultDate}
                                    disabled={disabledDefaultFlag}
                                />
                                {/* <LocalizationProvider
                                    dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        // inputProps={{ readOnly: true }}
                                        disabled={disabledDefaultFlag}
                                        label="Activity Date Time"
                                        value={
                                            playerDate === null
                                                ? null
                                                : playerDate ===
                                                      '0001-01-01T00:00:00' ||
                                                  playerDate.match(
                                                      '0001-01-01'
                                                  ) !== null
                                                ? null
                                                : playerDate
                                        }
                                        onChange={(newValue) => {
                                            setDefaultDate(newValue);
console.log(newValue)
                                            handleDisableBtn();
                                        }}
                                        cancelText
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                fullWidth
                                                size="small"
                                            />
                                        )}
                                    />
                                </LocalizationProvider> */}
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>
                                <TextField
                                    disabled={disabledDefaultFlag}
                                    id="deafulttime"
                                    label="Activity Time"
                                    type="time"
                                    value={
                                        playerDate === null
                                            ? '-- :-- --'
                                            : playerDate ===
                                                '0001-01-01T00:00:00'
                                                ? null
                                                : dayjs(playerDate).format(
                                                    'HH:mm:ss'
                                                )
                                    }
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    size="small"
                                    onChange={(newValue) => {
                                        setDefaultTime(newValue.target.value);
                                        handleDisableBtn();
                                    }}
                                />
                            </Box>
                            <Box>
                                <Tooltip title='Clear Date and Time'>
                                    <IconButton onClick={() => { handleClearActivityDateTime() }}>
                                        <CancelIcon color='primary'></CancelIcon>
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                        <Divider />
                        {locationInfo &&
                            locationInfo.length > 0 &&
                            locationInfo.map((val, index) => {
                                // console.log("val", val);
                                return (
                                    <Grid
                                        container
                                        key={index}
                                        lg={12}
                                        md={12}
                                        xs={12}
                                        sx={{ width: '100%', marginTop: 4 }}>
                                        <Grid
                                            item
                                            xs={12}
                                            md={3}
                                            sx={{
                                                pr: 2,
                                                wordBreak: 'break-all',
                                                mt: 2,
                                            }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                }}>
                                                {val.name + ' (' + val.location + ')'}
                                            </Box>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={5}
                                            md={4}
                                            sx={{ pr: 2, mt: 2 }}>
                                            <MUIDatePicker
                                                label="Activity Date Time"
                                                value={
                                                    val.scheduleDateTime ===
                                                        null
                                                        ? null
                                                        : val.scheduleDateTime ===
                                                            '0001-01-01T00:00:00' ||
                                                            val.scheduleDateTime.match(
                                                                '0001-01-01'
                                                            ) !== null
                                                            ? null
                                                            : val.scheduleDateTime
                                                }
                                                error={false}
                                                setValue={(newValue) => {
                                                    setActivityDate(
                                                        newValue
                                                    ),
                                                        setCustomActivitydate(
                                                            newValue,
                                                            val.mediaCircuitID
                                                        );
                                                    handleDisableBtn();
                                                }}
                                                disabled={disabledFlag}
                                            />
                                            {/* <LocalizationProvider
                                                dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    // inputProps={{ readOnly: true }}
                                                    disabled={disabledFlag}
                                                    label="Activity Date Time"
                                                    value={
                                                        val.scheduleDateTime ===
                                                        null
                                                            ? null
                                                            : val.scheduleDateTime ===
                                                                  '0001-01-01T00:00:00' ||
                                                              val.scheduleDateTime.match(
                                                                  '0001-01-01'
                                                              ) !== null
                                                            ? null
                                                            : val.scheduleDateTime
                                                    }
                                                    onChange={(newValue) => {
                                                        setActivityDate(
                                                            newValue
                                                        ),
                                                            setCustomActivitydate(
                                                                newValue,
                                                                val.mediaCircuitID
                                                            );
                                                        handleDisableBtn();
                                                    }}
                                                    cancelText
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            size="small"
                                                        />
                                                    )}
                                                />
                                            </LocalizationProvider> */}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={5}
                                            md={4}
                                            sx={{ mt: 2 }}>
                                            <TextField
                                                disabled={disabledFlag}
                                                id="time"
                                                label="Activity Time"
                                                type="time"
                                                value={
                                                    val.scheduleDateTime ===
                                                        null
                                                        ? '--:-- --'
                                                        : val.scheduleDateTime ===
                                                            '0001-01-01T00:00:00'
                                                            ? '--:-- --'
                                                            : dayjs(
                                                                val.scheduleDateTime
                                                            ).format('HH:mm:ss')
                                                }
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                size="small"
                                                onChange={(newValue) => {
                                                    setActivityTime(
                                                        newValue.target.value
                                                    );
                                                    setCustomActivityTime(
                                                        newValue.target
                                                            .value,
                                                        val.mediaCircuitID
                                                    );
                                                    handleDisableBtn();
                                                }}
                                            />
                                            <span style={{ marginLeft: 8 }}>
                                                <Tooltip title='Clear Date and Time'>
                                                    <IconButton onClick={() => { handleClearActivityDateTime(val.mediaCircuitID) }}>
                                                        <CancelIcon color='primary'></CancelIcon>
                                                    </IconButton>
                                                </Tooltip>
                                            </span>
                                        </Grid>
                                    </Grid>
                                );
                            })}
                    </>
                ) : (
                    <Box style={loader}>
                        <CircularProgress />
                    </Box>
                )}
            </>
        );
    };


    const renderDialogActions = () => {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                <Button
                    variant="outlined"
                    sx={{ width: '100px !important', marginTop: '16px' }}
                    onClick={handleReset}>
                    Reset
                </Button>
                <ButtonContainer
                    showLoading={true}
                    loading={loading.get()}
                    handleClick={handleClick}
                    handleCancel={props.handleClose}
                    buttonText={'Update'}
                    disableUpdateButton={disableBtn}
                />
            </Box>
        );
    };

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
        />
    );
};

export default EditParticipant;
